import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { usePopper } from 'react-popper';

import * as Styled from './styles';

const Tooltip = ({ target, children }) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'top',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 20],
        },
      },
    ],
  });

  return (
    <>
      <div ref={setReferenceElement}>{target}</div>

      <Styled.Container
        ref={setPopperElement}
        data-popper-placement="top"
        bg="white"
        borderRadius={6}
        style={styles.popper}
        {...attributes.popper}
      >
        {children}
      </Styled.Container>
    </>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  target: PropTypes.node.isRequired,
};

export default Tooltip;
